@use '@lib/assets/styles/main.scss' as *;

.root {
  display: flex;
}
